import script from "./SLS07_006INS.vue?vue&type=script&setup=true&lang=js"
export * from "./SLS07_006INS.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__